module.exports = __webpack_public_path__ + "static/e-handle-your-return-a91a24c1a4b44526a74cb1a052d628dc.png";